import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  transition: all 0.3s;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
  }

  ${({ open }) =>
    open
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `};
`;

export const Modal = styled.div`
  padding: 20px;
  max-width: 1200px;
  background: #ffffff;
  position: relative;

  @media screen and (max-width: 768px) {
    padding-top: 50px;
    height: 100vh;
    width: 100%;
    overflow: auto;

    button {
      align-self: center;
    }
  }

  form {
    display: flex;
    align-items: flex-start;
    flex-direction: column;

    label {
      font-family: "Open Sans";
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 136.02%;
      color: #000000;

      margin: 16px 0 8px;
    }

    input,
    textarea {
      background: #e0f1f9;
      border: 1px solid #1485c7;
      border-radius: 12px;
      width: 100%;

      @media screen and (max-width: 768px) {
        background: ${({ theme }) => theme.colors.grayLight};
        border: 1px solid #000000;
      }
    }

    input {
      height: 36px;
    }

    textarea {
      height: 72px;
      margin-bottom: 30px;
    }
  }
`;

export const ModalHead = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > button {
    background: transparent;
    border: 1px solid transparent;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
`;

export const FormDesc = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  h2 {
    margin: 20px 0 20px;
  }

  p {
    margin: 10px 0 30px;
  }
`;
